import { PARTICLE, SLIDESHOW } from "./consts";
import { insertParticle } from "./common";
import addAssemblerParticle from "./particleItem";
import addAssemblerSlideshow from "./slideshowParticleItem";
import injectAssemblerAds from "./ads";
import particleNotify from "./notification";

const handlersMap = {
    [PARTICLE]: addAssemblerParticle,
    [SLIDESHOW]: addAssemblerSlideshow,
};

export default function addAssemblerItem(container, data, settings) {
    const handler = handlersMap[data.itemType];
    const particleElement = handler ? handler(data, settings) : null;
    insertParticle(container, injectAssemblerAds(settings.post.id));
    insertParticle(container, particleElement);
    particleNotify(particleElement);
    return particleElement;
}
